module.exports = __webpack_public_path__ + "static/media/27.ac5033f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/27.png
// module id = 1401
// module chunks = 0